import { Link } from "react-router-dom";
import { homeURL } from "src/settings/config";

export default function SidebarHeader() {
    return (
        <div className="flex items-center justify-center flex-shrink-0 p-2">
            <Link to={homeURL}>
                <span className="flex flex-col justify-center items-center p-0 text-lg font-medium leading-8 tracking-wider whitespace-nowrap">
                    <img src="/assets/img/logos/logo3.png" className="w-full" />
                    {/* <span>کسائی</span> */}
                </span>
            </Link>
        </div>
    )
}